window.addEventListener('error', () => document.body.classList.remove('is-page-loading'));
